import { useMemo } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';

import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';
import endpointsResource from 'src/actions/endpoints/endpointsResource';
import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import useResource from 'src/presentation/hooks/useResource';
import { STATUS_SUCCEEDED, STATUS_LOADING, allSucceeded } from 'src/presentation/hooks/useResource';

export const useEndpointsWithInboxes = () => {
  const {
    values: endpoints,
    loadingState: endpointsLoadingState,
    errors: endpointsErrors,
  } = useResource(endpointsResource);
  const { values: communicationQueues, loadingState: communicationQueuesState } =
    useResource(communicationQueuesResource);
  const { values: inboxes, loadingState: inboxesState } = useResource(routingGroupsResource);

  const endpointsWithInboxes: any = useMemo(() => {
    return map(endpoints, endpoint => {
      const list = communicationQueues
        .filter(({ endpointId }) => endpointId === endpoint.id)
        .map(({ routingGroupId }) => {
          const inbox = inboxes.find(({ id }) => id === routingGroupId);
          return get(inbox, 'name');
        });
      let inboxesField;
      if (list.length) {
        inboxesField = list.join(', ');
      }

      return { ...endpoint, inboxes: inboxesField };
    });
  }, [communicationQueues, inboxes, endpoints]);

  const isAllSucceeded = allSucceeded(endpointsLoadingState, inboxesState, communicationQueuesState);
  const loadingState = isAllSucceeded ? STATUS_SUCCEEDED : STATUS_LOADING;

  return { endpoints: endpointsWithInboxes, endpointsErrors, loadingState };
};
